module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot479-1200x2490.4657291d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot479-1200x2490.jpg
// module id = 1072
// module chunks = 37